enum CLIENT_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

enum FILE_TYPES {
  JOB = 1,
  AGG = 2,
  DOC = 3,
  QC = 4,
}

const jobStatus = {
  ENQUEUE: 1,
  INPROCESS: 2,
  DONE: 3,
  FAILED: 4,
}

const jobStatusDescription = (code: number) => {
  if (code === jobStatus.ENQUEUE) {
    return 'Enqueued'
  }

  if (code === jobStatus.INPROCESS) {
    return 'In Process'
  }

  if (code === jobStatus.DONE) {
    return 'Completed'
  }

  if (code === jobStatus.FAILED) {
    return 'Failed'
  }

  return 'Unknown'
}

export { jobStatus, jobStatusDescription, FILE_TYPES, CLIENT_TYPE }
